import { Tooltip } from "@mui/material";
import { EditIcon } from "../../../assets/icons/Icons";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { GeneralButton } from "../../../common/ui/GeneralButton";

interface EditBtnProps {
  handleOnClick: () => void;
  hoverText?: string;
}

const EditBtn: FC<EditBtnProps> = ({ handleOnClick, hoverText }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={hoverText ? hoverText : t("label.editItems")}>
      <GeneralButton appVariant="icon" onClick={handleOnClick}>
        <EditIcon />
      </GeneralButton>
    </Tooltip>
  );
};

export default EditBtn;
